import { EventEmitter, Output } from '@angular/core';
import { throwError } from 'rxjs';
import { User } from '../models/user';
import { AppFunctionGroup } from '../models/app-function-group';
import { GeneralSetting } from '../models/generalsetting';
import { Agencies } from '../models/agencies';
import { DatePipe } from '@angular/common';
import { DwUtils } from "../components/utils/dw-utils";
import { ServiceDef } from '../models/service-def';
import { ServiceRequestType } from '../models/service-request-type';
import { Region } from "../models/region";
import { RequestStatus } from '../models/request-status';
import { DocumentCategory } from '../models/document-category';
import { CaseStatus } from '../models/case-status';
import { StatusReasons } from '../models/status-reasons';
import { SearchQBE } from '../models/searchqbe';
import { environment } from 'src/environments/environment';

class DataRecord {
	id: string;
	description: string;
	constructor(id: string, description: string) {
		this.id = id;
		this.description = description;
	}
}
export class Settings {

	private static instance: Settings;
	private static monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
		'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
	];

	public BASE_URL = environment.apiUrl;
	user: User;
	loggedInUser: User;
	public usersList: User[];
	public agencyList: Agencies[];
	public documentCategoryList: DocumentCategory[];
	public regionsList: Region[];
	public serviceRequestTypesList: ServiceRequestType[];
	public caseStatusList: CaseStatus[];
	public serviceDefsList: ServiceDef[];
	public allStatusReasons: StatusReasons[];
	public uomList;
	public requestStatuses: RequestStatus[];
	public completeAppFunctionGroupsList: AppFunctionGroup[];
	public version = 'x.x.x';
	public lastUpdated = 'yyyy/mm/dd';
	public release = 'staging';

	public generalSettingsList: GeneralSetting[];

	public timeLineSelectionList: any[];
	public enableMessageBanner = false;
	public strBannerText = '';
	public userList: Array<User>;

	public strErr = '';
	public CURRENCY_SYMBOL = '$';
	public InactivityTimeoutMinutes = 10;
	public GlobalSearchResultLimitRequests = 200;
	public GlobalSearchResultLimitCases = 200;
	public RequestGridAutoRefreshMinutes = 1;
	public supportEmailAddress = 'agency@theconnectorwga.org';
	public enableAutoEventEmail = 'No';
	public EmailOptOutAgencyIds = [];
	public AvtarDocumentCategoryId = 5;

	public onToggleFullScreen: EventEmitter<boolean>;
	public showMessageEvent: EventEmitter<any>;
	public loginRequestEvent: EventEmitter<any>;
	public logoutRequestEvent: EventEmitter<any>;
	public _jwtToken: any;
	public location: Location;
	public isEditing = false;
	
	public GlobalSearchResultRequests: any;
	public GlobalSearchResultCases: any;
	public GlobalSearchQBERequests: SearchQBE;
	public GlobalSearchQBECases: SearchQBE;

	constructor() {

	}
	get jwtToken(): any {
		if (this._jwtToken == null || this._jwtToken === undefined || this._jwtToken.length === 0) {
			this._jwtToken = localStorage.getItem('jwt_token');
		}
		return this._jwtToken;
	}
	set jwtToken(value: any) {
		this._jwtToken = value;
		localStorage.setItem('jwt_token', value);
	}
	public static convertJsonDate(jsonDate): Date {
		if (jsonDate === null || jsonDate === '') {
			return null;
		}
		return new Date(jsonDate);
	}
	public static getInstance(): Settings {
		if (Settings.instance == null) {
			Settings.instance = new Settings();
			Settings.instance.timeLineSelectionList = new Array();
			Settings.instance.onToggleFullScreen = new EventEmitter<boolean>();
			Settings.instance.showMessageEvent = new EventEmitter<any>();
			Settings.instance.loginRequestEvent = new EventEmitter<any>();
			Settings.instance.logoutRequestEvent = new EventEmitter<any>();
		}
		return Settings.instance;
	}

	public static dateLabelFunction(rowData: any, column: any): string {
		if (rowData[column.field] === null || rowData[column.field] === undefined) {
			return;
		}
		const retVal = rowData[column.field].substr(0, 10);
		return retVal;
	}
	public static timeLabelFunction(rowData: any, column: any): string {
		if (rowData[column.field] === null || rowData[column.field] === undefined) {
			return;
		}
		const retVal = rowData[column.field].substr(11, 8);
		return retVal;
	}
	public static getMonthCount(startDate: Date, endDate: Date): number {
		if (startDate == null || endDate == null) {
			return 0;
		}
		return (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth()) + 1;
	}
	public static returnDateFromString(inpString: string): Date {
		if (inpString == null || inpString.length === 0) {
			return null;
		}
		const dateParts = inpString.split('/');
		const month: number = parseInt(dateParts[0], 10);
		const date: number = parseInt(dateParts[1], 10);
		const year: number = parseInt(dateParts[2], 10);
		return new Date(year, month - 1, date);
	}

	public static filterResourceList(sourceList: any, str: string): any {
		const revisedDataList: Array<any> = [];
		if (str !== undefined && str != null) {
			str = str.toLowerCase();
		}
		for (let i = 0; i < sourceList.length; i++) {
			const obj = sourceList[i];
			if (str === '' || str === undefined || str === null) {
				revisedDataList.push(obj);
			} else {
				if (obj.name.toLowerCase().indexOf(str) >= 0 || obj.username.toLowerCase().indexOf(str) >= 0 || (obj.Reference != null && obj.Reference.toLowerCase().indexOf(str) >= 0)) {
					revisedDataList.push(obj);
				}
			}
		}
		return revisedDataList;
	}

	public static invitationStatusLabeler(row): string {
		if (row['invitationStatus'] == null || row['invitationStatus'] == undefined) {
			return 'Not Invited';
		} else if (row['invitationStatus'] == -1) {
			return '';
		} else if (row['invitationStatus'] == 0 && row['invitationCount'] > 0 && row['lastInvitationDate'] !== undefined) {
			const invitationDate: Date = Settings.returnDateFromString(row['lastInvitationDate']);
			if ((new Date()).getTime() - invitationDate.getTime() > (72 * 60 * 60 * 1000)) {
				return 'Invitation Expired';
			} else {
				return 'Invitation Sent';
			}
		} else if (row['invitationStatus'] == 1 && row['invitationCount'] > 0) {
			return 'Invitation Accepted';
		} else {
			return 'Not Invited';
		}
	}
	public static invitationStatusLabeler1(row): string {
		if (row['invitationStatus'] == null || row['invitationStatus'] === undefined) {
			return 'Not Invited';
		} else if (row['invitationStatus'] === -1) {
			return '';
		} else if (row['invitationStatus'] === 0 && row['invitationCount'] > 0) {

			return 'Invitation Sent';

		} else if (row['invitationStatus'] === 1 && row['invitationCount'] > 0) {
			return 'Invitation Accepted';
		} else {
			return 'Not Invited';
		}
	}

	public handleError(error, calledFrom = '') {
		let titleStr = 'Error';
		let errorMessage = '';

		// no need to show a dialog box with OK
		if (String(error).toUpperCase() === 'OK') {
			return;
		}
		/* if (error.status === 401) {
			this.logoutRequestEvent.emit();
			return;
		} */
		/**** If it is a forbidden then just return to the login page ***/
		if (error.status === 403) {

			this.logoutRequestEvent.emit();
			return;
		}

		if (error.error instanceof ErrorEvent) {
			// Get client-side error
			errorMessage = error.error.message;
		} else if (error === 'Unknown Error') {
			errorMessage = 'Error: unable to communicate with server';

		}
		if (typeof error === 'string' || error instanceof String) {
			errorMessage = error as string;
		}
		else {
			// Get server-side error
			errorMessage = '<div style="fontSize: 13pt; lineHeight: 4px;">';
			errorMessage += 'Error Code ....: <b>' + error.status + ' - ' + error.statusText + '</b><br />';
			errorMessage += 'Message .......: <b>' + error.message + '</b><br />';
			errorMessage += 'Asserting ......: <b>' + error.url + '</b>';
			if (calledFrom.length > 0) {
				errorMessage += '<br/>Attempt ........: <b>' + calledFrom + '</b>';
			}
			errorMessage += '</div>';
		}

		if (errorMessage.toString().includes('Success')) {
			titleStr = 'Result';
		}

		this.showMessageEvent.emit({ title: titleStr, message: errorMessage, showClose: true });
		return throwError(errorMessage);

	}
	hasPrivilege(param: string, rightType: string='WRITE'): boolean {
		if ((this.loggedInUser === undefined) || (this.loggedInUser.security_elements === undefined)) {
			return false;
		}
		for (const rec of this.loggedInUser.security_elements) {
			if (rec.role === param) {
				if (rec.rightType === rightType) {
					return true;
				} else {
					//TODO: This is making it a bit too permissive, but it is needed for the
					//case where a user has WRITE, but the rightType is READ
					if(rec.rightType === "WRITE") {
						return true;
					}
					if(rec.rightType === "EXECUTE" && (rightType === "READ" || rightType === "SHOW")) {
						return true;
					}
					if(rec.rightType === "READ" && (rightType === "SHOW")) {
						return true;
					}
					if(rec.rightType === "SHOW" && (rightType === "READ")) {
						return true;
					}
				}
			}
		}
		return false;
	}
	hasReadOnlyPrivilege(param: string): boolean {
		if (!this.loggedInUser || !this.loggedInUser.security_elements) {
			return false;
		}
		for (const rec of this.loggedInUser.security_elements) {
			if (rec.role === param && (rec.rightType === 'READ' || rec.rightType === 'SHOW')) {
				return true;
			}
		}
		return false;
	}

	public isPrimaryAgency(agencyId: number): boolean {
		if (agencyId === undefined) {
			return false;
		}
		/** Allows The Admin role to view as an agency admin regardless **/
		if (Settings.getInstance().hasPrivilege('ADMIN','EXECUTE') === true) {
			return true;
		}
		if (agencyId === Settings.getInstance().loggedInUser.agencyId) {
			return true;
		}
		return false;
	}
	getGeneralSettingByKey(paramKey: string): GeneralSetting {
		if (this.generalSettingsList === null || this.generalSettingsList === undefined) {
			return null;
		}
		try {
			for (const rec of this.generalSettingsList) {
				if (rec.key === paramKey) {
					return rec;
				}
			}
			return null;
		} catch (err) {
			return null;
		}
	}

	getResourceFullName(userid): string {
		if (this.usersList === undefined || this.usersList.length === 0) {
			return '';
		}
		for (const rec of this.usersList) {
			if (rec.username === userid) {
				return rec.name;
			}
		}
		return userid;
	}
	getAgencyName(id): string {
		if (this.agencyList === undefined || this.agencyList.length === 0) {
			return '';
		}
		for (const rec of this.agencyList) {
			if (rec.id === id) {
				return rec.agencyName;
			}
		}
		return '';
	}
	getAgencyRecord(id: number): any {
		if (this.agencyList === undefined || this.agencyList.length === 0) {
			return null;
		}
		for (const rec of this.agencyList) {
			if (rec.id === id) {
				return rec;
			}
		}
		return null;
	}
	getAgencyEmail(id): string {
		if (this.agencyList === undefined || this.agencyList.length === 0) {
			return '';
		}
		const agency = this.agencyList.find(s => s.id === id);

		if (agency === undefined) {
			return '';
		}

		return agency.emailAddress;
	}
	getCountyDataSource(addOtherFlag: boolean = false): any {

		const retArray = new Array();
		let lastCounty = ''

		if ((this.regionsList === undefined) || (this.regionsList.length === 0)) {
			return retArray;
		}

		for (let rec of this.regionsList) {

			if (rec.county != lastCounty) {
				retArray.push(new DataRecord(rec.county, rec.description));
			}
			lastCounty = rec.county;
		}
		if (addOtherFlag === true) {
			retArray.push(new DataRecord('Other', 'Other'));
		}

		return retArray;
	}
	getCountyFromZipCode(zipCode: string): string {
		let retStr = '';
		if ((zipCode === undefined) || (zipCode.length === 0)) {
			return retStr;
		}
		retStr = this.regionsList.find(s => s.zipCode === zipCode).county;
		return retStr;
	}
	getServiceDefDescription(defId): string {
		if (this.serviceDefsList === undefined || this.serviceDefsList.length === 0) {
			return '';
		}
		const serviceDef: ServiceDef = this.getServiceDef(defId);
		if (!serviceDef) {
			return '';
		}
		const serviceRequestType: ServiceRequestType = this.getServiceRequestType(serviceDef.serviceRequestTypeId);
		if (!serviceRequestType) {
			return '';
		}
		return serviceRequestType.description + ': ' + serviceDef.description;
	}
	getServiceRequestType(id) {
		for (const rec of this.serviceRequestTypesList) {
			if (rec.id === id) {
				return rec;
			}
		}
		return undefined;
	}
	getServiceRequestTypeDesc(id) {
		for (const rec of this.serviceRequestTypesList) {
			if (rec.id === id) {
				return rec.description;
			}
		}
		return id;
	}
	getStatusResonDesc(id) {
		for (const rec of this.allStatusReasons) {
			if (rec.id === id) {
				return rec.description;
			}
		}
		return "NA";
	}
	getRecordStatusDesc(status) {
		switch (status) {
			case 0:
				return "Completed";
			case 1:
				return "Open";
			default:
				return status;
		}
	}
	getServiceDef(id) {
		for (const rec of this.serviceDefsList) {
			if (rec.id === id) {
				return rec;
			}
		}
		return undefined;
	}
	getRequestStatusDesc(id) {
		for (const rec of this.requestStatuses) {
			if (rec.id === id) {
				return rec.shortDescription;
			}
		}
		return id;
	}
	formatDate(date: Date | string, format: string = 'MM/dd/yyyy', locale: string = 'en-US'): string {
		const datePipe = new DatePipe(locale);
		const isoDate = typeof date === 'string' ? date : DwUtils.returnTZTime(date); // date.toISOString();
		return datePipe.transform(isoDate, format);
	}

	convertStringToDate(dateString: string): Date | null {
		const dateParts = dateString.split('/');

		if (dateParts.length === 3) {
			const day = parseInt(dateParts[0], 10);
			const month = parseInt(dateParts[1], 10);
			const year = parseInt(dateParts[2], 10);

			if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
				// Months are 0-based in JavaScript Date, so subtract 1 from the month
				return new Date(year, month - 1, day);
			}
		}

		return null;
	}
	public checkDateChange(dt1: string, dt2: string): string | undefined {
		if(dt1 == null || dt1 == undefined) {
			if(dt2 == null || dt2 == undefined) {
				return undefined;
			}
			return dt2.slice(0, 10)+"T12:00:00.000Z";
		}
		// Extract the date parts (first 10 characters: YYYY-MM-DD)
		const datePart1 = dt1.slice(0, 10);
		const datePart2 = dt2.slice(0, 10);
		
		// Check if the date parts are equal
		if (datePart1 === datePart2 || datePart2==null || datePart2==undefined) {
		  return dt1;
		}
		 
		return datePart2+"T12:00:00.000Z";
	}
	public isEmailOptoutAgency(agencyId: number): boolean {
		return this.EmailOptOutAgencyIds.some((element) => element === agencyId);
	}
	public replaceWithSingleUnderscore(input: string): string {
		return input.replace(/[^a-zA-Z0-9]+/g, '_');
	}
}
